// Air Intelligence Console palette ("Palantir slate"). The console is dark by
// design whatever the app theme: it's an operations display, and the aircraft
// colours below only read against a dark ground. Colour always means something:
// it never decorates.

export const AIR = {
  bg: '#0B0E13',
  panel: '#11161D',
  panel2: '#161C25',
  line: '#1E2630',
  lineStrong: '#2A3442',
  text: '#C9D1D9',
  bright: '#E6EDF3',
  muted: '#6B7685',
  dim: '#4A5361',
  civil: '#8B98A9',
  military: '#F2A23A',
  emergency: '#FF4D4F',
  privacy: '#A78BFA',
  watched: '#22D3EE',
  accent: '#3FB6A8', // interactive accent (selection, focus, primary actions)
  water: '#0D1520',
  land: '#0F141B',
} as const

export const FONT_MONO = '"JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, Consolas, monospace'
export const FONT_UI = 'Inter, ui-sans-serif, system-ui, -apple-system, "Segoe UI", sans-serif'

export type AircraftClass = 'emergency' | 'watched' | 'privacy' | 'military' | 'civil'

export const CLASS_COLOR: Record<AircraftClass, string> = {
  emergency: AIR.emergency,
  watched: AIR.watched,
  privacy: AIR.privacy,
  military: AIR.military,
  civil: AIR.civil,
}

export const CLASS_LABEL: Record<AircraftClass, string> = {
  emergency: 'Emergency',
  watched: 'Watched',
  privacy: 'Privacy-listed',
  military: 'Military',
  civil: 'Civil',
}

export const EMERGENCY_LABEL: Record<string, string> = {
  HIJACK: '7500 Unlawful interference',
  RADIO_FAILURE: '7600 Radio failure',
  EMERGENCY: '7700 Emergency',
}

export function classify(a: { emg?: string; mil?: boolean; ladd?: boolean; pia?: boolean; hex: string }, watched: Set<string>): AircraftClass {
  if (a.emg) return 'emergency'
  if (watched.has(a.hex)) return 'watched'
  if (a.mil) return 'military'
  if (a.ladd || a.pia) return 'privacy'
  return 'civil'
}

export const fmtAlt = (a: { alt?: number; gnd?: boolean }) =>
  a.gnd ? 'GND' : a.alt == null ? '—' : a.alt >= 18000 ? `FL${Math.round(a.alt / 100).toString().padStart(3, '0')}` : `${a.alt.toLocaleString()} ft`

export const fmtAgo = (epochSec: number) => {
  const s = Math.max(0, Math.round(Date.now() / 1000 - epochSec))
  if (s < 60) return `${s}s ago`
  if (s < 3600) return `${Math.round(s / 60)}m ago`
  return `${Math.round(s / 3600)}h ago`
}
